// Primary colors
export const darkBlue = "#01689b";
export const lightBlue = "#cce0f1";

// Error, warning, info, success colors
export const success = "#2E9634";
export const warning = "#FFDE3C";
export const info = "#EF5D12";
export const error = "#CE1F00";

// other colors
export const darkGrey = "#262628";
export const grey = "#7e7e7e";
export const white = "#ffffff";
export const tintColor = "#fafafb";
export const offBlack = "#1a1a1a";
export const offGrey = "#f3f3f3";

// Organization colors
export const organisationBlue = "#8FCAE7";
export const organisationLightBlue = "#E5F0F9";
export const offWhite = "#f8f8f8";
export const greyBlue = "#E4EBF1";
